// extracted by mini-css-extract-plugin
export default {"loginCon":"styles_loginCon__yqMxf","body":"styles_body__Bnqry","flex":"styles_flex__EGsZ6","btn":"styles_btn__2l5V-"};